import { render } from "./Cropper.vue?vue&type=template&id=6afd61cb"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"

import "./Cropper.vue?vue&type=style&index=0&id=6afd61cb&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__